import axios from 'axios';

export const genericSearch = async (keyword) => {
  try {
    const res = await axios.get(`/api/v1/genericsearch?keyword=${keyword}`);
    return res.data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};
